import React, {Component} from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import {Mutation} from 'react-apollo'

import LoadingButton from "../LoadingButton";
import {ProjectWriteoffInput} from "./ProjectWriteoffInput";
import upsertWriteoffMutation from '../../../queries/server/mutations/upsert_project_writeoff'
import removeWriteoffMutation from '../../../queries/server/mutations/remove_project_writeoff'
import editProjectLocalMutation from '../../../queries/client_side/mutations/edit_project'
import {toast} from "react-toastify";

const {format} = Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
})

export default class ProjectWriteoffListItem extends Component {

    state = {
        editing: false
    }

    render() {

        const {writeoff, project_id, project, canEdit, canRemove} = this.props
        const {editing} = this.state


        return (
            <Mutation mutation={editProjectLocalMutation}>
                {(editProjectLocalMutationFunc) => (
                    <div className="d-flex flex-row align-items-center justify-content-between border-bottom pt-2 pb-2">
                        {editing ?
                            <Mutation mutation={upsertWriteoffMutation}>
                                {(upsertWriteoffMutationFunc, {loading}) => (

                                    <ProjectWriteoffInput
                                        {...writeoff}
                                        loading={loading}
                                        budgets={project.project_activity_budgets}
                                        onCancel={() => this.setState({editing: false})}
                                        onAdd={(data) => {
                                            upsertWriteoffMutationFunc({
                                                variables: {
                                                    data: {...data, project_id},
                                                    project_id
                                                }
                                            })
                                                .then(({data}) => {
                                                    toast.success('Write Off Updated', {autoClose: 2000})
                                                    editProjectLocalMutationFunc({
                                                        variables: {
                                                            data: data.upsertProjectWriteoff
                                                        }
                                                    })
                                                    this.setState({editing: false})
                                                })
                                                .catch(e => toast.error(e.message, {autoClose: false}))
                                        }}
                                    />


                                )}
                            </Mutation> :
                            <div className="d-flex flex-row align-items-center justify-content-between"
                                 style={{flex: 1}}>
                                <div className="d-flex flex-column">
                                    <p className="font-weight-light p-0 m-0" style={{flex: 1}}>
                                        {format(writeoff.amount)}
                                    </p>
                                    <small>
                                        {writeoff.description}
                                    </small>
                                    <small>
                                        {moment(writeoff.written_off_at).format('DD/MM/YYYY')}
                                    </small>
                                    <small>
                                        {writeoff.created_by_user.full_name}
                                    </small>
                                </div>

                                <div className="d-flex flex-row">
                                    <LoadingButton
                                        icon="edit"
                                        loading={false}
                                        size="sm"
                                        color="warning"
                                        className="square-btn mr-1"
                                        forceDisabled={!canEdit}
                                        onClick={() => this.setState({editing: true})}
                                    />

                                    <Mutation mutation={removeWriteoffMutation}>
                                        {(removeWriteoffMutationFunc, {loading}) => (
                                            <LoadingButton
                                                icon="trash-alt"
                                                loading={loading}
                                                size="sm"
                                                color="danger"
                                                className="square-btn"
                                                forceDisabled={!canRemove}
                                                onClick={() => {
                                                    removeWriteoffMutationFunc({
                                                        variables: {
                                                            id: writeoff.id,
                                                            project_id
                                                        }
                                                    })
                                                        .then(({data}) => {
                                                            toast.success('Write Off Removed', {autoClose: 2000})
                                                            editProjectLocalMutationFunc({
                                                                variables: {
                                                                    data: data.removeProjectWriteoff
                                                                }
                                                            })
                                                            this.setState({editing: false})
                                                        })
                                                        .catch(e => toast.error(e.message, {autoClose: false}))
                                                }}
                                            />
                                        )}
                                    </Mutation>
                                </div>


                            </div>
                        }

                    </div>
                )}
            </Mutation>
        )

    }

}

ProjectWriteoffListItem.propTypes = {
    writeoff: PropTypes.object.isRequired,
    project: PropTypes.object.isRequired,
    canEdit: PropTypes.bool,
    canRemove: PropTypes.bool
}